// Stroke icons taken from the design screens (24x24, 1.5 stroke, currentColor).
const paths = {
  pair: ['M3 19h.01', 'M3 15a4 4 0 0 1 4 4', 'M3 11a8 8 0 0 1 8 8', 'M8 5h11a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-3'],
  bell: ['M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3H4a4 4 0 0 0 2-3v-3a7 7 0 0 1 4-6', 'M9 17v1a3 3 0 0 0 6 0v-1'],
  screen: ['M16 3l-4 4-4-4', 'M5 7h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z'],
  play: ['M7 4v16l13-8z'],
  qr: ['M5 4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z', 'M5 14h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z', 'M15 4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z', 'M7 17v.01M14 14v.01M20 14v.01M14 20v.01M17 17v.01M20 20v.01'],
  glass: ['M8 21h8M12 15v6', 'M5 3h14l-1.5 9a4 4 0 0 1-4 3.5h-3A4 4 0 0 1 6.5 12z'],
  licence: ['M18 15a3 3 0 1 1-6 0a3 3 0 0 1 6 0', 'M13 17.5V22l2-1.5 2 1.5v-4.5', 'M10 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10', 'M6 9h12M6 12h3M6 15h2'],
  megaphone: ['M18 8a3 3 0 0 1 0 6', 'M10 8v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-5', 'M12 8l4.5-3.8a.9.9 0 0 1 1.5.7v12.2a.9.9 0 0 1-1.5.7L12 14H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z'],
  close: ['M6 6l12 12M18 6L6 18'],
  map: ['M9 11a3 3 0 1 0 6 0a3 3 0 0 0-6 0', 'M17.7 15.7L12 21.4l-5.7-5.7a8 8 0 1 1 11.4 0'],
  venues: ['M3 21h18M5 21V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16M15 9h3a1 1 0 0 1 1 1v11M9 8h2M9 12h2M9 16h2'],
  reports: ['M4 19h16M6 16v-5M10 16V8M14 16v-3M18 16V5'],
  settings: ['M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0', 'M4 12h2M18 12h2M12 4v2M12 18v2M6.3 6.3l1.4 1.4M16.3 16.3l1.4 1.4M6.3 17.7l1.4-1.4M16.3 7.7l1.4-1.4'],
  chevronDown: ['M6 9l6 6 6-6'],
  chevronRight: ['M9 6l6 6-6 6'],
  search: ['M17 10a7 7 0 1 1-14 0a7 7 0 0 1 14 0', 'M21 21l-6-6'],
  alert: ['M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0', 'M12 8v4M12 16h.01'],
  back: ['M5 12h14M11 6l-6 6 6 6'],
  info: ['M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0', 'M12 11v5M12 8h.01'],
  swap: ['M4 7h11l-3-3M20 17H9l3 3'],
  sound: ['M15 8a5 5 0 0 1 0 8M17.7 5a9 9 0 0 1 0 14M6 15H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2l3.5-4.5A.8.8 0 0 1 11 5v14a.8.8 0 0 1-1.5.5z'],
  drop: ['M12 3l5 6.5a6 6 0 1 1-10 0z'],
  cup: ['M17 8h1a4 4 0 1 1 0 8h-1', 'M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z'],
  restart: ['M4 12a8 8 0 1 0 2.3-5.6', 'M4 4v5h5'],
  hex: ['M12 2.5l8.2 4.75v9.5L12 21.5l-8.2-4.75v-9.5z'],
  // Added for master control admin areas, drawn to the same grid and stroke.
  users: ['M9 11a4 4 0 1 0 0-8a4 4 0 0 0 0 8', 'M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2', 'M16 3.1a4 4 0 0 1 0 7.8', 'M21 21v-2a4 4 0 0 0-3-3.9'],
  plus: ['M12 5v14M5 12h14'],
  key: ['M15 9a3 3 0 1 1-6 0a3 3 0 0 1 6 0', 'M12 12v9M12 17h3M12 20h2'],
  broadcast: ['M12 12h.01', 'M8.5 15.5a5 5 0 0 1 0-7M15.5 8.5a5 5 0 0 1 0 7', 'M5.6 18.4a9 9 0 0 1 0-12.8M18.4 5.6a9 9 0 0 1 0 12.8'],
  check: ['M5 12l5 5L20 7'],
  history: ['M12 8v4l3 2', 'M3.05 11a9 9 0 1 1 .5 4', 'M3 4v7h7'],
} as const;

export type IconName = keyof typeof paths;

export function Icon({ name, size = 20, title }: { name: IconName; size?: number; title?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      {paths[name].map((d, i) => (
        <path key={i} d={d} />
      ))}
    </svg>
  );
}
